"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportStocks = exports.EXPORT_STOCKS = void 0;
exports.EXPORT_STOCKS = '/backoffice/v2/stocks';
const exportStocks = (client) => async (sellerId, storableIds) => {
    const storableIdsQueryParam = storableIds?.length ? `&storableIds=${storableIds.join(',')}` : '';
    const res = await client.get(exports.EXPORT_STOCKS + `?sellerId=${sellerId}${storableIdsQueryParam}`);
    return res.data;
};
exports.exportStocks = exportStocks;
